import dayjs from 'dayjs';

import { getQrCode } from 'api/QRCode';
import { getAccessoryTypes } from 'api/accessoryTypes';
import { getUserCompany, getCompany } from 'api/company';
import { getContainers } from 'api/containers';
import { getMaterials } from 'api/materials';
import { getPartners, importPartners } from 'api/partners';
import { getProject } from 'api/projects';
import { getRegionals } from 'api/regionals';
import { getTrainings, getUserTrainings } from 'api/training';
import { getUser, importUser } from 'api/users';
import { getVehicleAccessories } from 'api/vehicleAccessories';
import { getVehicles } from 'api/vehicles';
import Dispatch from 'containers/Modals/Dispatch';
import { ContentRoutes } from 'enums/routes';
import { RouteStatus, GeneralStatus, ActivityStatus } from 'enums/status';
import {
  FrequencyTypes, MethodTypes, PartnerTypes, VehicleContractTypes,
} from 'enums/types';

export const newButtonText = {
  [ContentRoutes.Routes]: 'Criar nova rota',
  [ContentRoutes.Users]: 'Novo Usuário',
  [ContentRoutes.Roles]: 'Nova Permissão',
  [ContentRoutes.Regionals]: 'Nova Regional',
  [ContentRoutes.Materials]: 'Novo Material',
  [ContentRoutes.Containers]: 'Nova Embalagem',
  [ContentRoutes.Project]: 'Novo Projeto',
  [ContentRoutes.Partner]: 'Criar novo parceiro',
  [ContentRoutes.Checklists]: 'Novo Check-list',
  [ContentRoutes.Vehicles]: 'Criar Veículo',
  [ContentRoutes.AccessoryTypes]: 'Criar Tipo de Acessório',
  [ContentRoutes.VehicleAccessories]: 'Adicionar Acessório',
  [ContentRoutes.Drivers]: 'Novo Condutor',
  [ContentRoutes.Trainings]: 'Novo Treinamento',
  [ContentRoutes.QRCode]: 'Novo grupo de QrCodes',
  [ContentRoutes.Companies]: 'Nova empresa',
  [ContentRoutes.SuperUsers]: 'Novo super usuário',
};

export const getters = {
  [ContentRoutes.Users]: getUser,
  [ContentRoutes.Regionals]: getRegionals,
  [ContentRoutes.Containers]: getContainers,
  [ContentRoutes.Materials]: getMaterials,
  [ContentRoutes.Company]: getUserCompany,
  [ContentRoutes.Project]: getProject,
  [ContentRoutes.Partner]: getPartners,
  [ContentRoutes.Vehicles]: getVehicles,
  [ContentRoutes.AccessoryTypes]: getAccessoryTypes,
  [ContentRoutes.VehicleAccessories]: getVehicleAccessories,
  [ContentRoutes.Drivers]: getUser,
  [ContentRoutes.Trainings]: getTrainings,
  [ContentRoutes.UsersTrainings]: getUserTrainings,
  [ContentRoutes.QRCode]: getQrCode,
  [ContentRoutes.Companies]: getCompany,
  [ContentRoutes.SuperUsers]: getUser,
};

export const importFn = {
  [ContentRoutes.Users]: importUser,
  [ContentRoutes.Drivers]: importUser,
  [ContentRoutes.Partner]: importPartners,
};

export const tableDisplay = {
  [ContentRoutes.Routes]: [
    { accessor: 'code', type: 'text', Header: 'CÓD' },
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'project.name', type: 'text', Header: 'PROJETO' },
    { accessor: 'regional.name', type: 'text', Header: 'REGIONAL' },
    { accessor: 'source', type: 'text', Header: 'ORIGEM' },
    { accessor: 'destination', type: 'text', Header: 'DESTINO' },
    { accessor: 'frequency', type: 'frequency', Header: 'FREQUENCIA' },
    {
      accessor: 'executionsCount', type: 'text', Header: 'N DE EXECUÇÕES',
    },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Drivers]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'documentNumber', type: 'text', Header: 'CNH' },
    {
      accessor: 'documentNumberDueDate', type: 'date', Header: 'VALIDADE',
    },
    {
      accessor: 'partner', type: 'partner', Header: 'PARCEIRO',
    },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Users]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'role.name', type: 'text', Header: 'TIPO DE PERMISSÃO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.SuperUsers]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'email', type: 'text', Header: 'EMAIL' },
    {
      accessor: 'createdAt',
      type: 'text',
      Header: 'ADICIONADO EM',
      formatter: (date: string) => dayjs(date).format('DD/MM/YYYY'),
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Roles]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'type', type: 'text', Header: 'TIPO DE PERMISSÃO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'relatedUsers', type: 'text', Header: 'USUÁRIOS' },
  ],
  [ContentRoutes.Regionals]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'area', type: 'text', Header: 'LOCALIDADE' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Materials]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'packaging', type: 'text', Header: 'TIPO DE ACONDICIONAMENTO' },
    { accessor: 'temperature', type: 'text', Header: 'TEMPERATURA' },
    { accessor: 'type', type: 'text', Header: 'TIPO DE MATERIAL' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
  ],
  [ContentRoutes.Containers]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'cubage', type: 'weight', Header: 'CUBAGEM' },
    { accessor: 'dimensions', type: 'text', Header: 'DIMENSÕES' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
  ],
  [ContentRoutes.Project]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Partner]: [
    { accessor: 'code', type: 'text', Header: 'CÓD.' },
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'corporateName', type: 'text', Header: 'NOME FANTASIA' },
    { accessor: 'type', type: 'text', Header: 'TIPO' },
    { accessor: 'regional.name', type: 'text', Header: 'REGIONAL' },
    { accessor: 'address.city', type: 'text', Header: 'CIDADE' },
    { accessor: 'relatedRoutes', type: 'text', Header: 'ROTAS' },
    { accessor: 'contact', type: 'text', Header: 'CONTATO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Companies]: [
    { accessor: 'code', type: 'text', Header: 'CÓD.' },
    { accessor: 'corporateName', type: 'text', Header: 'NOME FANTASIA' },
    { accessor: 'type', type: 'text', Header: 'TIPO' },
    { accessor: 'relatedRoutes', type: 'text', Header: 'ROTAS' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Checklists]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'type', type: 'text', Header: 'TIPO' },
    { accessor: 'frequency', type: 'text', Header: 'FREQUENCIA' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Vehicles]: [
    { accessor: 'licensePlate', type: 'text', Header: 'PLACA' },
    { accessor: 'contract', type: 'text', Header: 'PROPRIETÁRIO' },
    { accessor: 'partner.name', type: 'text', Header: 'PARCEIRO' },
    { accessor: 'type', type: 'text', Header: 'TIPO' },
    { accessor: 'manufacturer', type: 'text', Header: 'FABRICANTE' },
    { accessor: 'model', type: 'text', Header: 'MODELO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.AccessoryTypes]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    { accessor: 'accessoriesCount', type: 'text', Header: 'QUANTIDADE' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
  ],
  [ContentRoutes.VehicleAccessories]: [
    { accessor: 'serialNumber', type: 'text', Header: 'Nº DE SÉRIE' },
    { accessor: 'assetNumber', type: 'text', Header: 'Nº DE PATRIMÔNIO' },
    {
      accessor: 'calibrationDate', type: 'date', Header: 'DATA DA CALIBRAÇÃO',
    },
    {
      accessor: 'calibrationDueDate', type: 'date', Header: 'VALIDADE DA CALIBRAÇÃO',
    },
    { accessor: 'vehicle.licensePlate', type: 'text', Header: 'VEÍCULO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Dispatch]: [
    { accessor: 'trackingCode', type: 'text', Header: 'AWB/CTE' },
    { accessor: 'operator', type: 'text', Header: 'OPERADORA' },
    { accessor: 'dispatchSource', type: 'partner', Header: 'ORIGEM' },
    { accessor: 'dispatchDestination', type: 'partner', Header: 'DESTINO' },
    { accessor: 'route.code', type: 'text', Header: 'ROTA' },
    { accessor: 'sourceName', type: 'text', Header: 'REMETENTE' },
    { accessor: 'destinationName', type: 'text', Header: 'DESTINATÁRIO' },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.Trainings]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    {
      accessor: 'startDate', type: 'date', Header: 'INÍCIO',
    },
    {
      accessor: 'dueDate', type: 'date', Header: 'TÉRMINO',
    },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'status', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.UsersTrainings]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    {
      accessor: 'startDate', type: 'date', Header: 'INÍCIO',
    },
    {
      accessor: 'dueDate', type: 'date', Header: 'TÉRMINO',
    },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    { accessor: 'trainingStatus', type: 'status', Header: 'STATUS' },
  ],
  [ContentRoutes.QRCode]: [
    { accessor: 'name', type: 'text', Header: 'NOME' },
    {
      accessor: 'amount', type: 'text', Header: 'QUANTIDADE',
    },
    {
      accessor: 'company', type: 'partner', Header: 'EMPRESA', superUserOnly: true,
    },
    {
      accessor: 'createdAt', type: 'text', Header: 'CRIADO EM',
    },
  ],
};

export const ordinations = {
  [ContentRoutes.Routes]: {
    code: 'code',
    name: 'name',
    project: 'project',
    regional: 'regional',
    source: 'source',
    destination: 'destination',
    frequency: 'frequency',
    executionStatus: 'executionStatus',
    company: 'company',
  },
  [ContentRoutes.Drivers]: {
    name: 'name',
    documentNumber: 'documentNumber',
    documentNumberDueDate: 'documentNumberDueDate',
    'partner.name': 'partner',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Users]: {
    name: 'name',
    'role.name': 'role',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.SuperUsers]: {
    name: 'name',
    email: 'email',
    createdAt: 'createdAt',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Roles]: {
    name: 'name',
    type: 'type',
    company: 'company',
  },
  [ContentRoutes.Materials]: {
    name: 'name',
    packaging: 'packaging',
    temperature: 'minTemperature',
    type: 'type',
    company: 'company',
  },
  [ContentRoutes.Containers]: {
    name: 'name',
    cubage: 'cubage',
    dimensions: 'width',
    company: 'company',
  },
  [ContentRoutes.Project]: {
    name: 'name',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Partner]: {
    code: 'code',
    name: 'name',
    corporateName: 'corporateName',
    type: 'type',
    'regional.name': 'regional',
    'address.city': 'address',
    relatedRoutes: 'relatedRoutes',
    contact: 'contact',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Companies]: {
    code: 'code',
    name: 'name',
    corporateName: 'corporateName',
    type: 'type',
    'address.city': 'address',
    contact: 'contact',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Checklists]: {
    name: 'name',
    type: 'type',
    frequency: 'frequency',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Vehicles]: {
    licensePlate: 'licensePlate',
    contract: 'contract',
    'partner.name': 'partner.name',
    type: 'vehicleType.type',
    manufacturer: 'manufacturer',
    model: 'vehicleType.name',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.AccessoryTypes]: {
    name: 'nome',
    company: 'company',
  },
  [ContentRoutes.VehicleAccessories]: {
    serialNumber: 'serialNumber',
    assetNumber: 'assetNumber',
    calibrationDate: 'calibrationDate',
    calibrationDueDate: 'calibrationDueDate',
    'vehicle.licensePlate': 'vehicle.licensePlate',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Dispatch]: {
    trackingCode: 'trackingCode',
    operator: 'operator',
    dispatchSource: 'dispatchSource',
    'route.code': 'route',
    dispatchDestination: 'dispatchDestination',
    sourceName: 'sourceName',
    destinationName: 'destinationName',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.Trainings]: {
    name: 'name',
    startDate: 'startDate',
    dueDate: 'dueDate',
    status: 'status',
    company: 'company',
  },
  [ContentRoutes.UsersTrainings]: {
    name: 'name',
    startDate: 'startDate',
    dueDate: 'dueDate',
    status: 'trainingStatus',
    company: 'company',
  },
  [ContentRoutes.QRCode]: {
    name: 'name',
    amount: 'amount',
    createdAt: 'createdAt',
    company: 'company',
  },
};

export const baseFilters = {
  [ContentRoutes.Routes]: {
    select: [
      { key: 'project.name', label: 'Projeto' },
      { key: 'regional.name', label: 'Regional' },
      { key: 'source', label: 'Origem' },
      { key: 'destination', label: 'Destino' },
    ],
    checkbox: {
      frequency: Object.values(FrequencyTypes),
      executionStatus: Object.values(RouteStatus),
    },
  },
  [ContentRoutes.Users]: {
    select: [
      { key: 'name', label: 'Nome' },
      { key: 'role.name', label: 'Tipo de permissão' },
      { key: 'company.name', label: 'Empresa', policy: `user.${MethodTypes.SuperUser}` },
    ],
    checkbox: { status: Object.values(GeneralStatus) },
  },
  [ContentRoutes.SuperUsers]: {
    select: [
      { key: 'name', label: 'Nome' },
      { key: 'email', label: 'Email' },
    ],
    checkbox: { status: Object.values(GeneralStatus) },
  },
  [ContentRoutes.Partner]: {
    select: [
      { key: 'address.city', label: 'Cidade' },
      { key: 'regional.name', label: 'Regional' },
    ],
    checkbox: { status: Object.values(GeneralStatus), type: Object.values(PartnerTypes) },
  },
  [ContentRoutes.Companies]: {
    select: [
      { key: 'address.city', label: 'Cidade' },
      { key: 'name', label: 'Nome' },
      { key: 'code', label: 'Code' },
    ],
    checkbox: { status: Object.values(GeneralStatus) },
  },
  [ContentRoutes.Vehicles]: {
    select: [
      { key: 'licensePlate', label: 'Placa' },
      { key: 'partner.name', label: 'Parceiro' },
      { key: 'manufacturer', label: 'Fabricante' },
      { key: 'vehicleType.name', label: 'Modelo' },
      { key: 'vehicleType.type', label: 'Tipo' },
    ],
    checkbox: {
      status: Object.values(GeneralStatus),
      contract: Object.values(VehicleContractTypes),
    },
  },
  [ContentRoutes.VehicleAccessories]: {
    select: [
      { key: 'serialNuber', label: 'Nº de Série' },
      { key: 'assetNuber', label: 'Nº de Patrimônio' },
      { key: 'vehicle.licensePlate', label: 'Veículo' },
    ],
    checkbox: {
      status: Object.values(GeneralStatus),
    },
  },
  [ContentRoutes.Dispatch]: {
    select: [
      { key: 'operator', label: 'OPERADORA' },
      { key: 'trackingCode', label: 'AWB/CTE' },
      { key: 'dispatchSource.name', label: 'ORIGEM' },
      { key: 'dispatchDestination.name', label: 'DESTINO' },
      { key: 'sourceName', label: 'REMETENTE' },
      { key: 'dispatchDestination', label: 'DESTINATÁRIO' },
      { key: 'assetNuber', label: 'Nº de Patrimônio' },
      { key: 'vehicle.licensePlate', label: 'Veículo' },
    ],
    checkbox: {
      status: Object.values(ActivityStatus),
    },
  },
  [ContentRoutes.QRCode]: {
    select: [
      { key: 'name', label: 'Nome' },
    ],
  },
};

export const actions = {
  [ContentRoutes.Routes]: { // Rotas ainda não foi atualizada e não deve ser modificada!
    onTrash: 'disable',
    onEdit: 'show',
    onShow: 'show',
    onCreate: 'page',
    onImport: null,
  },
  [ContentRoutes.Drivers]: {
    onTrash: 'disable',
    onEdit: 'show',
    onShow: 'show',
    onCreate: 'modal',
    onImport: 'file',
  },
  [ContentRoutes.Users]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: 'file',
  },
  [ContentRoutes.SuperUsers]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Roles]: {
    onTrash: 'delete',
    onEdit: 'show',
    onShow: 'show',
    onCreate: 'page',
    onImport: null,
  },
  [ContentRoutes.Regionals]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: null,
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Materials]: {
    onTrash: 'delete',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Containers]: {
    onTrash: 'delete',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Project]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Partner]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: 'file',
  },
  [ContentRoutes.Companies]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'page',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Checklists]: {
    onTrash: 'disable',
    onEdit: 'show',
    onShow: 'show',
    onCreate: 'page',
    onImport: null,
  },
  [ContentRoutes.Vehicles]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.AccessoryTypes]: {
    onTrash: 'delete',
    onEdit: 'modal',
    onShow: 'table',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.VehicleAccessories]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.Dispatch]: {
    onTrash: null,
    onEdit: null,
    onShow: 'modal',
    onCreate: null,
    onImport: null,
  },
  [ContentRoutes.Trainings]: {
    onTrash: 'disable',
    onEdit: 'modal',
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
  [ContentRoutes.UsersTrainings]: {
    onTrash: null,
    onEdit: null,
    onShow: 'show',
    onCreate: null,
    onImport: null,
  },
  [ContentRoutes.QRCode]: {
    onTrash: 'delete',
    onEdit: null,
    onShow: 'show',
    onCreate: 'modal',
    onImport: null,
  },
};

export const showPages = {
  [ContentRoutes.Companies]: '/company',
};

export const subTables = {
  [ContentRoutes.AccessoryTypes]: ContentRoutes.VehicleAccessories,
};
export const breadcrumbParent = {
  [ContentRoutes.VehicleAccessories]: 'accessoryType.name',
};

export const modals = {
  [ContentRoutes.Routes]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar essa Rota?',
      message: () => `A rota será desativada e arquivada,
      podendo ser acessada apenas para visualizaçao do histórico.
      Motoristas que já tiverem iniciado poderão finalizar a rota.`,
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Rota desativada',
      message: () => 'A Rota foi desativada e seu histórico estará disponível apenas para consultas.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Drivers]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Condutor?',
      message: () => 'Ao desativar o Condutor, não será possível vinculá-lo a novas rotas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Condutor Desativado',
      message: () => 'O Condutor foi desativado e não poderá ser vinculado a novas rotas.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Users]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Usuário?',
      message: () => 'Ao desativar o usuário, ele perderá o acesso a todas as permissões na plataforma.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Usuário Desativado',
      message: () => 'O usuário foi desativado e não terá mais acesso a plataforma.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.SuperUsers]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Usuário?',
      message: () => 'Ao desativar o usuário, ele perderá o acesso à plataforma.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Usuário Desativado',
      message: () => 'O usuário foi desativado e não terá mais acesso a plataforma.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Roles]: {
    block: {
      title: () => 'Usuários vinculados à Permissão',
      message: ({ relatedUsers }) => `Existem ${relatedUsers} usuários vinculados a essa Permissão. Antes de prosseguir, altere as permissões dos usuários.`,
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Editar Usuários',
        action: 'filter role',
      },
    },
    confirmation: {
      title: () => 'Tem certeza que deseja de excluir essa Permissão?',
      message: ({ name }) => `Após excluir a permissão ${name} ela não poderá ser acessada.`,
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Excluir',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Permissão Excluída',
      message: ({ name }) => `A Permissão ${name} foi excluída e não poderá ser acessada.`,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Regionals]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar essa Regional?',
      message: () => 'Após desativar a regional ela não poderá ser acessada.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Regional desativada',
      message: () => 'A Regional foi desativada com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Materials]: {
    confirmation: {
      title: () => 'Tem certeza que deseja excluir este material?',
      message: () => 'O material será permanentemente excluída e não poderá mais ser adicionada a Rotas. As Rotas que já tiverem sido realizadas com essa carga continuarão registradas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Excluir material',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Material Excluído',
      message: ({ name }) => `O Material ${name} foi excluída e não poderá ser acessada.`,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Containers]: {
    confirmation: {
      title: () => 'Tem certeza que deseja excluir esta embalagem?',
      message: () => 'O embalagem será permanentemente excluída e não poderá mais ser adicionada a Rotas. As Rotas que já tiverem sido realizadas com essa carga continuarão registradas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Excluir embalagem',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Embalagem Excluído',
      message: ({ name }) => `O Embalagem ${name} foi excluída e não poderá ser acessada.`,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Project]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Projeto?',
      message: () => 'Ao desativar este Projeto, ele não poderá ser vinculado a nenhuma rota ou outra entidade. As Rotas e entidades previamente vinculadas continuarão visíveis.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Projeto desativado',
      message: () => 'O Projeto foi desativado com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Partner]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Parceiro?',
      message: () => 'Ao desativar o parceiro, não será possível vinculá-lo a novas rotas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Parceiro Desativado',
      message: () => 'O parceiro foi desativado com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Companies]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar essa Empresa?',
      message: () => 'Ao desativar esta Empresa, todos os usuários vinculados terão seus acessos à plataforma bloqueados.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Empresa desativada',
      message: () => 'A Empresa foi desativada com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Checklists]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Check-list?',
      message: ({ name }) => `Após desativar o  ${name} ela não poderá ser atribuída a nenhuma Rota.`,
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Check-list Desativado',
      message: ({ name }) => `O ${name} foi excluído e não poderá ser acessada ou atribuído.`,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Vehicles]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Veículo?',
      message: () => 'Ao desativar esse Veículo, não será possível vinculá-lo a novas Rotas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Veículo desativado',
      message: () => 'O Veículo foi desativado com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.AccessoryTypes]: {
    confirmation: {
      title: () => 'Tem certeza que deseja excluir este Acessório?',
      message: () => 'O Acessório Veicular será permanentemente excluído e não poderá mais ser adicionada a Rotas. As Rotas que já tiverem sido realizadas com esse Acessório continuarão registradas.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Excluir Acessório',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Acessório Excluído',
      message: ({ name }) => `O Acessório ${name} foi excluído e não poderá ser acessado. `,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.VehicleAccessories]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar este Acessório?',
      message: () => 'O Acessório Veicular será desativado e não poderá mais ser adicionado em Rotas futuras. ',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Acessório Desativado',
      message: ({ serialNumber }) => `O Acessório Veicular ${serialNumber} foi desativado com sucesso. `,
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.Trainings]: {
    confirmation: {
      title: () => 'Tem certeza que deseja desativar esse Treinamento?',
      message: () => 'Ao desativar esse Treinamento, não será possível designá-los a Usuários.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Desativar',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'Treinamento desativado',
      message: () => 'O Treinamento foi desativado com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
  [ContentRoutes.QRCode]: {
    confirmation: {
      title: () => 'Tem certeza que deseja excluir esse grupo de QrCodes?',
      message: () => 'Ao excluir esse Treinamento, não será possível baixar as imagens.',
      secondaryButton: {
        text: 'Cancelar',
        action: 'onClear',
      },
      primaryButton: {
        text: 'Excluir',
        action: 'mutate',
      },
    },
    success: {
      title: () => 'grupo excluido',
      message: () => 'O grupo foi excluido com sucesso.',
      primaryButton: {
        text: 'Concluir',
        action: 'success',
      },
    },
  },
};

export const displayModal = {
  [ContentRoutes.Dispatch]: Dispatch,
};
